module.exports = __webpack_public_path__ + "static/media/crm.19f77134.svg";